import { useMemo, useState } from "react";
import { AutoComplete } from "@volca/ui/components/ui/autocomplete";
import { getUserFullName } from "@/core/utils/name";
import { useGetNonAdminUsers } from "@/user/query";

interface UserSelectorProps {
  businessId?: string | null;
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  fullWidth?: boolean;
  required?: boolean;
}

export const UserSelector = ({
  businessId,
  value,
  onChange,
  label = "User",
  placeholder = "Select a user",
  fullWidth = false,
  required = false,
}: UserSelectorProps) => {
  const [userSearch, setUserSearch] = useState("");
  const {
    data: users = [],
    isLoading,
    isError,
  } = useGetNonAdminUsers(businessId);

  const userOptions = useMemo(
    () =>
      users.map((user) => ({
        value: user.id,
        label: getUserFullName(user) || user.email || "",
      })),
    [users],
  );

  return (
    <AutoComplete
      label={label}
      selectedValue={value}
      onSelectedValueChange={onChange}
      searchValue={userSearch}
      onSearchValueChange={setUserSearch}
      items={userOptions.filter((option) =>
        option.label.toLowerCase().includes(userSearch.toLowerCase()),
      )}
      isLoading={isLoading}
      emptyMessage={
        isError ? "Couldn’t load users. Please try again." : "No users found"
      }
      placeholder={placeholder}
      required={required}
      fullWidth={fullWidth}
    />
  );
};
